var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('payment-upload-form',{on:{"upload:complete":_vm.handleUploadComplete}}),_c('payment-upload-list',{attrs:{"imports":Object.values(_vm.data)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }